import { movies } from '@/mocks/movies';
import type { Movie } from '@/mocks/movies';

export default function HotMovies() {
  const hotMovies = movies.filter((m: Movie) => m.isHot);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在看的热门影视</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide" data-product-shop>
          {hotMovies.map((movie: Movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="flex-shrink-0 w-[180px] md:w-[200px] group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-[3/4]">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  title={`${movie.title} - 丫丫影院免费在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {movie.rating}
                  </span>
                </div>
                {movie.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                      NEW
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 truncate">
                {movie.category} · {movie.year}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/action"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}